export async function useAPI(url) {
	try {
		const runtimeConfig = useRuntimeConfig();
		const backendUrl = runtimeConfig.public.backendUrl;

		var data = await useFetch(backendUrl + "/api/v1/" + url, {
			$fetch: useNuxtApp().$api
		})

		return data.data.value.data;
	} catch (error) {
		console.log("URL", url);
		console.log(error);
	}
}
